import { useState } from "react";

export type ModalType =
    | "delete"
    | "end"
    | "info"
    | "upload"
    | "restore"
    | "deleteWithoutInput"
    | "active"
    | "exportCsv"
    | "importData";

interface UseModalReturn<T> {
    showModal: boolean;
    modalData: {
        title: string;
        subtitle: string;
        subtitle2?: string;
        type: ModalType;
    };
    errorModal: { [key: string]: string | undefined };
    endDate: Date | null;
    motiveDelete: string | null;
    setMotiveDelete: (motive: string | null) => void;
    startDate: Date | null;
    currentId: number;
    currentItem?: T | null;
    isLoading: boolean;
    setLoading: (loading: boolean) => void;
    openModal: (event: T | null, title: string, subtitle: string, type: ModalType, subtitle2: string) => void;
    closeModal: () => void;
    setEndDate: (date: Date | null) => void;
    setStartDate: (date: Date | null) => void;
    setErrorModal: (error: { [key: string]: string | undefined }) => void;
    onEndDateChange?: (date: Date | null) => void;
    handleFileChange?: (file: File | null) => void;
}

export function useModal<T>(): UseModalReturn<T> {
    const [showModal, setShowModal] = useState(false);           // Modal visibility
    const [errorModal, setErrorModal] = useState<{ [key: string]: string | undefined }>({});  // Error messages
    const [isLoading, setIsLoading] = useState(false);          // Loading state
    const [endDate, setEndDate] = useState<Date | null>(null);  // End date selection
    const [motiveDelete, setMotiveDelete] = useState<string | null>(null);  // Motive delete selection
    const [startDate, setStartDate] = useState<Date | null>(null); // Start date reference
    const [currentId, setCurrentId] = useState<number>(0); // Active event ID
    const [currentItem, setCurrentItem] = useState<T | null>(null);

    const [modalData, setModalData] = useState<{
        title: string;
        subtitle: string;
        subtitle2: string;
        type: ModalType;
    }>({
        title: "default",
        subtitle: "default",
        subtitle2: "default",
        type: "delete"
    });

    const openModal = (item: T | null, title: string, subtitle: string, type: ModalType, subtitle2: string) => {

        if (type === 'end' && item) { 
            setCurrentId((item as any).id);
            setEndDate(new Date());
        }
        if (type === 'delete' && item) {
            setCurrentId((item as any).id);
            setCurrentItem(item)
            setMotiveDelete("")
        }
        if (type === 'deleteWithoutInput' && item) {
            setCurrentId((item as any).id);
            setCurrentItem(item)
        }
        else if (type === 'exportCsv' && item)
            setCurrentId((item as any).id);

        else if (type === 'active' && item)
            setCurrentId((item as any).id);
        
        setCurrentItem(item);
        setShowModal(true);
        setModalData({
            title: title,
            subtitle: subtitle,
            subtitle2: subtitle2,
            type: type
        });
    };

    const closeModal = () => {
        setIsLoading(false); // Reset loading state al cerrar
        setShowModal(false);
        setErrorModal({errorModal: ""})
    };

    const setLoading = (loading: boolean) => {
        setIsLoading(loading);
    };

   
    return {
        showModal,
        modalData,
        errorModal,
        motiveDelete,
        setMotiveDelete,
        endDate,
        startDate,
        currentId,
        currentItem,
        openModal,
        closeModal,
        setEndDate,
        setStartDate,
        setErrorModal,
        isLoading,
        setLoading
    };
}
